module.exports = __webpack_public_path__ + "images/feed-info1ca02b108ab19e498b2f22c46a983654.svg";